import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const formatStrToMoney = (valor) => {
  if (valor) {
    return Number(valor?.replace('.', '').replace('R$ ', '').replace(',', '.'));
  }
  return 0;
};

export const formatMoney = (valor) => {
  return valor?.toLocaleString('pt-br', { minimumFractionDigits: 2 });
};

export const createMoneyMaskRegex = () => {
  const defaultMaskOptions = {
    prefix: 'R$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    integerLimit: 7,
    allowNegative: false,
    allowLeadingZeroes: false,
  };
  return createNumberMask(defaultMaskOptions);
};

export function formatCurrencyBRL(value) {
  const currencyValueBRL = Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  return currencyValueBRL;
}

export function truthy(value) {
  return value === 'True' || value === 1 || value === true;
}

export function falsy(value) {
  if (value === 0) return true;

  return value !== 'True' && value !== true;
}
